export default __webpack_public_path__ + "static/media/Bifurcated-Accumulator-edit-1.346259a5.jpg";